export default {"src":"/_next/static/media/mainImage.e4389f68.gif","height":500,"width":500};